import React from 'react';
import * as R from 'ramda';
import liendirect from './../../../assets/images/svg/049-family.svg';
import autres from './../../../assets/images/svg/051-parents.svg';
import * as Loadings from '../../../constants/loadings/referent';
import { useSelector } from 'react-redux';
import parsePhoneNumber from 'libphonenumber-js';

export const ColapsedReferent = ({data, setIsEditing}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    //const gender = { male: 'Male', female: 'Female' };
    const referent = useSelector(state => state.referent)
    const representativeType = {direct: 'Family', other:'Other'};
    const representativeTypeFamily = ['', 'Fils/Fille', 'Parent', 'Frère/Soeur', 'Conjoint'];
    if (R.isNil(data)){
        return '';
    }
    const parsedPhoneNumber = !R.isNil(data.phoneNumber) && data.phoneNumber !== "" ? parsePhoneNumber(data.phoneNumber)?.formatInternational() : undefined;
    return (
        <div className={"card p-4 border border-light"}>
            <div className={"block mb-3"}>
                <div className="card text-capitalize flex-row align-items-center mb-3">
                    <img className="img-fluid my-auto mb-2 h-5 w-5 py-1" src={data.representativeType === representativeType.other ? autres : liendirect} alt={data.representativeType === representativeType.direct ? "lien familial direct" : "autres"} />
                    <h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">{data.representativeType === representativeType.other ? 'Autres' : representativeTypeFamily[data.representativeType]}</h2>
                </div>
                <div className="flex-row align-items-start mb-3">
                    <i className="eva lh-copy eva-calendar-outline mr-2 o-50"></i>
                    <p className="h5 lh-copy my-auto">{R.isNil(data.birthDate) ? "N/D" : new Date(data.birthDate).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                </div>
                <div className="flex-row align-items-start mb-3">
                    <i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
                    <p className="h5 lh-copy my-auto">{data.address.addressLine1} <br />{data.address.postalCode} {data.address.city}, {countries.getName(data.address.country, "fr", {select: "official"})}</p>
                </div>
                {
                    R.isNil(data.email) || data.email === "" ?
                        ''
                    :
                        <div className="flex-row align-items-start mb-3">
                            <i className="eva lh-copy eva-email-outline mr-2 o-50"></i>
                            <p className="h5 lh-copy my-auto text-break">{data.email}</p>
                        </div>
                }
                {
                    R.isNil(parsedPhoneNumber) || parsedPhoneNumber === "" ?
                        ''
                    :
                        <div className="flex-row align-items-start mb-3">
                            <i className="eva lh-copy eva-phone-outline mr-2 o-50"></i>
                            <p className="h5 lh-copy my-auto">{parsedPhoneNumber}</p>
                        </div>
                }
            </div>
            <div className="flex-row align-items-center">
                <button type="button" className={"btn btn-block btn-alert-info ml-auto loading-btn" + (referent.isLoading.includes(Loadings.FETCHING_USERREPRESENTATIVE) ? ' show': '') } name="refPrincipal" onClick={() => {
                    setIsEditing(true);
                }}>Modifier
                <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                    </button>
            </div>
        </div>
    )
}